/* eslint-disable import/no-cycle */

import { UserOption } from 'src/components/ui-kit/user-search-autocomplete';
import { BankOptionType } from './bank';
import { ProductType, ProductQuotaType } from './product';
import { ValueOf, CommonFieldType } from './utils';
import { TransactionType } from './transaction';

export type UserFilters = {
  name: UserOption | null;
  level: UserLevel | 'all' | string;
  verification: UserVerificationStatus | 'all';
};
export type UserFilterKey = keyof UserFilters;
export type UserFilterValue = ValueOf<UserFilters>;

export enum UserLevel {
  'LV0' = 'LV0',
  'LV1' = 'LV1',
  'LV2' = 'LV2',
  'LV3' = 'LV3',
  'LV4' = 'LV4',
  'LV5' = 'LV5',
}

export enum UserVerificationStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED',
}

export type UserType = {
  uid: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  verifyStatus: UserVerificationStatus;
  createdAt: string;
  updatedAt: string;
  otpExpireAt?: string;
  level: UserLevel;
  referralId: string;
  phoneNumber?: string;
  userBankAccount?: UserBankAccount;
  referral?: UserReferral;
  userWallet?: UserWallet;
  userProducts?: UserProduct[];
  approvedByUser?: UserType;
  verifyNote?: string;
  userProductPositionQuotas?: UserProductPositionQuota[];
  isEnable: boolean;
  isVerifyEmail: boolean;
  isPreRegistered?: boolean;
};

export type UserProductPositionQuota = CommonFieldType & {
  userId: string;
  productId: string;
  type: ProductQuotaType;
  amount: number;
  createdByUserId: string;
  user: UserType;
  product: ProductType;
  createdByUser: UserType;
  txType?: TransactionType;
};

export type UserBankAccount = CommonFieldType & {
  userId: string;
  bankName: string;
  accountNumber: string;
  accountName: string;
  bankId?: string;
  bank?: BankOptionType;
};

export type UserReferral = CommonFieldType & {
  refCode: string;
  refToUserId: string;
  status: string;
  refUsedAt?: string;
  refByUserId?: string;
};

export type UserWallet = CommonFieldType & {
  userId: string;
  credit: number;
  debt: number;
  pinCode: string;
  idCardImageUrl?: string;
  isCorrectCopyDoc?: boolean;
  isPolicyAgree?: boolean;
  deposit?: number;
  bankImageUrl?: string;
  accountNumber?: string;
  accountName?: string;
  bank?: BankOptionType | null;
  bookBankImageUrl?: string;
  firstName?: string;
  lastName?: string;
  address?: string;
  idCardNumber?: string;
};

export type UserProduct = CommonFieldType & {
  userId: string;
  productId: string;
  product: ProductType;
  amount: number;
};

export type UserLevelType = {
  id: UserLevel;
  name: UserLevel;
  description: string;
  buyFee: number;
  sellFee: number;
  approvedByUser?: UserType;
  createdAt: string;
  updatedAt: string;
};
